import * as core from '../../../../../../../core'
import * as attainSpecKit from '../attain-spec-kit'

export const RESOURCE = {
  payload: {
    alias: 'requirements-dashboard',
    appAlias: attainSpecKit.RESOURCE.payload.alias,
    description:
      'At-a-glance status of every requirement, with drill-down to detail',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Requirements',
    page: { alias: 'requirements-dashboard' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
